<template lang="pug">
  section.content
    .error-page
      h2.headline.text-yellow
        i.fa.fa-exclamation-circle
      .error-content
        h3 指定したページに対する閲覧権限がありません。
        p
          | 恐れ入りますが、
          router-link(:to="{name: 'top'}") TOPページ
          | に戻っていただくか、
          br
          | メニューのリンクから目的のページをお探しください。
        .bcard-btnbar
          router-link.btn.btn-default(:to="{name: 'top'}") TOPページに戻る
          |
          |
          button.btn.btn-default(@click="$router.go(-1)") 前のページに戻る
</template>

<script>
export default {
  name: 'PageUnauthorized'
}
</script>

<style scoped>
h2.headline {
  margin: 0;
  width: 170px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/static/PageUnauthorized.vue